import { createAction, props } from '@ngrx/store';

export const contentConfigFetched = createAction(
	'[Bootstrap] Content Config Fetched',
	props<{ contentConfig: { [key: string]: string } }>()
);
